import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { InputField } from '@/components/molecules/input-field'
import { useCardReaderSetting } from '@/hooks/self-checkin-device-settings/use-card-reader-setting'
import { modalDeviceFormStyle, modalDeviceInputStyle } from './modal-form-styles'
import { DeviceSettingsModalFrame, DeviceSettingsModalNavigationProps } from './modal-frame'

type Props = DeviceSettingsModalNavigationProps & {
  hotelId: string
}

export const CardReaderDeviceSettingsPanel: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { control, isDirty, isLoading, checkResult, save, cancel } = useCardReaderSetting(props.hotelId)

  return (
    <DeviceSettingsModalFrame {...props} isLoading={isLoading} isDirty={isDirty} onCancel={cancel} onSave={save}>
      <div css={modalDeviceFormStyle}>
        <div className="input-container">
          <div className="input-label">{t('Serial number')}</div>
          <Controller
            control={control}
            name="serialNumber"
            render={({ field: { onChange, value } }) => (
              <InputField value={value} marginBottom={0} customInputStyle={modalDeviceInputStyle} handleChangeData={onChange} />
            )}
          />
        </div>
        <div className="input-container">
          <div className="input-label">PC ID</div>
          <Controller
            control={control}
            name="pcId"
            render={({ field: { onChange, value } }) => (
              <InputField value={value} marginBottom={0} customInputStyle={modalDeviceInputStyle} handleChangeData={onChange} />
            )}
          />
        </div>
        {checkResult && <div className={checkResult.is_success ? 'connect-success-text' : 'connect-error-text'}>{checkResult.message}</div>}
      </div>
    </DeviceSettingsModalFrame>
  )
}
